import useAccountForUserDotCom from "@hooks/userDotCom/useAccountForUserDotCom";
import { useEffect } from "react";
import { USER_DOT_COM_ENABLED } from "@config/userDotCom";
import useUserDotComAuth from "@hooks/userDotCom/useUserDotComAuth";
import { waitForUserDotCom } from "@hooks/userDotCom/waitForUserDotCom";

const useUpdateUserDotCom = () => {
  const { account } = useAccountForUserDotCom();
  const { update } = useUserDotComAuth();
  const id = account?.id;
  const email = account?.email;

  useEffect(() => {
    if (!USER_DOT_COM_ENABLED || !id || !email) {
      return;
    }

    return waitForUserDotCom(() => update({ id, email }));
  }, [id, email, update]);
};

export default useUpdateUserDotCom;
